import { hashText } from "./teammateColor";
import type { TeammateAppearance } from "../types/teammates";

export const SHAPE_COUNT = 6;

const LOOKS: [number, number][] = [[0, 0], [-1, 0], [1, 0], [0, -1], [1, 1]];

const BLINK_DELAYS = [
  "[animation-delay:0s]",
  "[animation-delay:0.7s]",
  "[animation-delay:1.4s]",
  "[animation-delay:2.1s]",
  "[animation-delay:2.8s]",
  "[animation-delay:3.5s]",
];

export type TeammateFace = {
  shape: number;
  lookX: number;
  lookY: number;
  dotEyes: boolean;
  eyeY: number;
  eyeGap: number;
  blinkDelay: string;
  seed: number;
};

export function teammateFace(name: string, appearance?: TeammateAppearance | null): TeammateFace {
  const hash = hashText(`${name}:face`);
  const [lookX, lookY] = LOOKS[(hash >>> 3) % LOOKS.length];
  return {
    shape: appearance?.shape ?? hash % SHAPE_COUNT,
    lookX,
    lookY,
    dotEyes: appearance?.eyes ? appearance.eyes === "dot" : ((hash >>> 6) & 1) === 1,
    eyeY: 19 + ((hash >>> 7) % 3) - 1,
    eyeGap: 4.6 + ((hash >>> 9) % 3) * 0.6,
    blinkDelay: BLINK_DELAYS[(hash >>> 4) % BLINK_DELAYS.length],
    seed: hash >>> 11,
  };
}
